import { useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import {  useLocation, useNavigate } from 'react-router-dom'
import { loadUserByTokenThunk } from './loadUserByToken'
import { setInitializationComplete } from './authSlice'
import { validatePermission } from '../../../../utils/services/validatePermission'
const nonAuthRoutes = ['/login', '/forgotPassword', '/otp', '/resetpassword', '/resendEmail', '/commentsOnIncident']
const allowWhenAuthedRoutes = ['/commentsOnIncident']
const AuthInit = ({ children }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()

    const { isAuthorized, token, permissions, isInitializing } = useSelector(
        (state) => state.auth,
        shallowEqual
    )
    useEffect(() => {
        // Handle initialization completion
        if (isInitializing) {
            // If we have a token but are not authorized, try to load user
            if (token && !isAuthorized) {
                dispatch(loadUserByTokenThunk())
                return
            }
            
            // If no token and not on auth routes, redirect to login
            if (!token && !nonAuthRoutes.includes(location.pathname)) {
                dispatch(setInitializationComplete())
                navigate('/login')
                return
            }
            
            // If already authorized, complete initialization
            if (isAuthorized) {
                dispatch(setInitializationComplete())
                return
            }
            
            // If on auth routes and no token, complete initialization
            if (nonAuthRoutes.includes(location.pathname) && !token) {
                dispatch(setInitializationComplete())
                return
            }
        }

        // Handle navigation after initialization
        if (!isInitializing) {
            if (!isAuthorized && token) {
                dispatch(loadUserByTokenThunk())
            } else if (
                !isAuthorized &&
                !token &&
                !nonAuthRoutes.includes(location.pathname)
            ) {
                navigate('/login')
            } else if (
                isAuthorized &&
                token &&
                ((nonAuthRoutes.includes(location.pathname) &&
                    !allowWhenAuthedRoutes.includes(location.pathname) &&
                    validatePermission(permissions, 'dashboard', 'list')) ||
                    location.pathname === '/')
            ) {
                navigate('/')
            }
            else if (
                isAuthorized &&
                token &&
                ((nonAuthRoutes.includes(location.pathname) &&
                    !allowWhenAuthedRoutes.includes(location.pathname) &&
                    !validatePermission(permissions, 'dashboard', 'list')) ||
                    location.pathname === '/')
            ){
                navigate('/myincidents/myincidents')
            }
        }
    }, [token, isAuthorized, location.pathname, dispatch, navigate, permissions, isInitializing])

    return children
}

export default AuthInit
